import React, { useState } from "react";

import "yet-another-react-lightbox/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import ShowCards from "../../MainMenu/showCards";
import laddoo from "../../../images/logo/Breakfast/ladoo.webp";
import badusha from "../../../images/logo/Breakfast/Badusha.jpg";
import mysurpa from "../../../images/logo/Breakfast/Mysurpa.jpg";
import kajuKatli from "../../../images/logo/Breakfast/kaju_katli.webp";
import splMixture from "../../../images/logo/Breakfast/splMixture.jpeg";
import muruku from "../../../images/logo/Breakfast/muruku.webp";
import ribbonPakoda from "../../../images/logo/Breakfast/ribbonPakoda.jpg";

import ShowCards from "../../MainMenu/showCards";
import RSVPFrom from "../../RSVPFrom/RSVPFrom";

const SpecialMenusIndex = (props) => {
  const accordionId = "accordionExample";

  const [data, setData] = useState([
    { name: "Laddu", img: laddoo, active: false },
    { name: "Badusha", img: badusha, active: false },
    { name: "Mysurpa", img: mysurpa, active: false },
    { name: "Kaju Katli", img: kajuKatli, active: false },
    { name: "Spl.Mixture", img: splMixture, active: false },
    { name: "5 & 7 Round Muruku", img: muruku, active: false },
    { name: "Ribbon Pakoda", img: ribbonPakoda, active: false },
  ]);
  const [eveningSnacks, seteveningSnacks] = React.useState(
    JSON.parse(localStorage.getItem("evening"))
  );
  const [noonLunch, setNoonLunch] = React.useState(
    JSON.parse(localStorage.getItem("noon"))
  );
  console.log(noonLunch);
  const [menu, setMenu] = React.useState();

  function saveCheckboxValues(type) {
    const checkboxes = document.querySelectorAll(".noon");
    let checkedValues = [];

    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        checkedValues.push(checkbox.value);
      }
    });
    setNoonLunch(checkedValues);

    // if (checkboxes == true) {
    localStorage.setItem(type, JSON.stringify(noonLunch));

    // }
  }

  function eveningCheckboxValues(type) {
    const checkboxes1 = document.querySelectorAll(".evening");
    let checkedValues1 = [];

    checkboxes1.forEach(function (checkbox) {
      if (checkbox.checked) {
        checkedValues1.push(checkbox.value);
      }
    });
    seteveningSnacks(checkedValues1);

    // if (checkboxes == true) {
    localStorage.setItem(type, JSON.stringify(eveningSnacks));

    // }
  }

  const handleSubmit = (type) => {
    saveCheckboxValues(type);
  };
  const handleEvening = (type) => {
    eveningCheckboxValues(type);
  };

  return (
    <section className="wpo-contact-pg-section ">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              {" "}
              <div className="row">
                <div class="accordion" id="accordionExample">
                  <ShowCards data={data} setData={setData} id={accordionId} />
                </div>
              </div>
            </div>
            {/* <div className="wpo-contact-title">
                          <h2>Have Any Question?</h2>
                          <p>It is a long established fact that a reader will be distracted
                              content of a page when looking.</p>
                      </div> */}
          </div>
        </div>
      </div>
      <div className="row ">
        <div className="col ">
          <div
            class="modal"
            id="myModal"
            // style={{ marginTop: "5rem" }}
          >
            <div class="modal-dialog modal-dialog-scrollable">
              <div class="modal-content ">
                <div class="modal-header">
                  <h4 class="modal-title">Please fill up the form</h4>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div class="modal-body">
                  <RSVPFrom />
                </div>

                <div class="modal-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-contact-pg-section ">
        <div
          class="modal"
          id="myModal1"
          // style={{ marginTop: "5rem" }}
        >
          <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content ">
              <div class="modal-header">
                <h4 class="modal-title">Please fill up the form</h4>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div class="modal-body">
                <RSVPFrom />
              </div>

              <div class="modal-footer"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialMenusIndex;
